module.exports = __webpack_public_path__ + "static/media/black-jack.6d7f2254.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/games/black-jack.png
// module id = 2394
// module chunks = 7